import type { ReactNode } from 'react';

import { SidebarNavItem } from '@ipen/components';
import { Link, useLocation } from 'react-router-dom';

type Props = {
  active?: boolean;
  className?: string;
  exact?: boolean;
  href: string;
  icon?: ReactNode;
  title: string;
};

export const BackstageNavigationItem = ({
  active,
  className,
  exact,
  href,
  icon,
  title,
}: Props) => {
  const location = useLocation();

  const isExact = exact ?? (href === '/');
  const isRouteActive = isExact
    ? location.pathname === href
    : location.pathname === href || location.pathname.startsWith(`${href}/`);
  const isActive = active ?? isRouteActive;

  return (
    <SidebarNavItem
      active={isActive}
      className={className}
      component={Link}
      icon={icon}
      label={title}
      to={href}
    />
  );
};
